module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_movie-9a8c6416c2d3873e23f573a51e765b25.svg";